import { render } from "./Team.vue?vue&type=template&id=4de6202d"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=4de6202d&lang=css"
script.render = render

export default script